import {createRouter, createWebHistory} from 'vue-router'
import DefaultLayout from "@/layouts/DefaultLayout";
import Index from '../pages/IndexPage.vue'
import Transfer from '@/pages/TransferPage.vue';
import Messages from '@/pages/MessagesPage.vue';
import ForYou from '@/pages/ForYouPage.vue';
import ViewPage from '@/pages/ViewPage.vue';
import CurrencyExchange from '@/pages/CurrencyExchange.vue';
import LoginPage from '@/pages/LoginPage.vue';
import ContactUs from '@/pages/ContactUs.vue';
import PersonalSetup from "@/pages/PersonalSetup";
import ChangePassword from '@/components/setting/ChangePassword.vue';
import ForceChangePassword from '@/components/setting/ForceChangePassword.vue';
import ActivityLog from '@/components/setting/ActivityLog.vue';
import CustomAccount from '@/components/setting/CustomAccount.vue';
import FrequentBeneficiary from '@/components/setting/FrequentBeneficiary.vue';
import NotificationSettings from '@/components/setting/NotificationSettings.vue';
import PayPage from '@/pages/PayPage.vue';
import PayServices from '@/components/payment/PayServices.vue';
import PayState from '@/components/payment/PayState.vue';

const routes = [
    {
        path: '/', component: DefaultLayout, children: [
            {path: '', name: 'Index', component: Index},
            {path: '/transfer', name: 'Transfer', component: Transfer},
            {path: '/change-password', name: 'ForceChangePassword', component: ForceChangePassword},
            {path: '/messages', name: 'Messages', component: Messages, meta: {title: 'Messages'}},
            {path: '/operations', name: 'Operations', component: ForYou},
            {path: '/view/balance', name: 'ViewPage', component: ViewPage},
            {path: '/currency', name: 'Currency', component: CurrencyExchange},
            {path: '/contact-us', name: 'ContactUs', component: ContactUs, meta: {title: 'Contact Us'}},
            {path: '/pay', name: 'Payment', component: PayPage, children: [
                    {
                        path: 'services',
                        component: PayServices
                    },
                    {
                        path: 'state',
                        component: PayState
                    },
                ] },

            {
                path: '/setting', name: 'PersonalSetup', component: PersonalSetup, children: [
                    {
                        path: 'change-password',
                        component: ChangePassword
                    },
                    {
                        path: 'activity-log',
                        component: ActivityLog
                    },
                    {
                        path: 'custom-account',
                        component: CustomAccount
                    },
                    {
                        path: 'beneficiaries',
                        component: FrequentBeneficiary
                    },
                    {
                        path: 'notifications',
                        component: NotificationSettings
                    }
                ]
            },
        ],
    },
    {path: '/login', name: 'LoginPage', component: LoginPage}

]

const router = createRouter({
    history: createWebHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const publicPages = ['/login'] // مسیرهای بدون نیاز به auth
    const authRequired = !publicPages.includes(to.path)
    const token = localStorage.getItem('token')
    const forcePasswordChange = localStorage.getItem('force_password_change') === '1'
    const userStatus = localStorage.getItem('user_status')
    const tokenTimestamp = localStorage.getItem('token_timestamp')

    if (token && tokenTimestamp) {
        const now = Date.now()
        if (now - parseInt(tokenTimestamp) > 900 * 1000) {
            // توکن منقضی شده
            localStorage.removeItem('token')
            localStorage.removeItem('token_timestamp')
            return next('/login')
        }
    }


    if (!token && authRequired) {
        // بدون توکن و نیازمند auth → برگرد به لاگین
        return next('/login')
    }

    if (userStatus === 'suspended') {
        // می‌تونی پیام خطا رو هم در query params بفرستی
        return next({ path: '/login', query: { error: 'Your account is suspended' } })
    }

    if (forcePasswordChange) {
        // اگه اجبار تغییر پسورد فعال باشه و مسیر فعلی غیر از /change-password است
        if (to.path !== '/change-password') {
            return next('/change-password')
        }
    } else {
        // اگه اجبار تغییر پسورد غیرفعال است و کاربر روی /change-password است → هدایت به داشبورد
        if (to.path === '/change-password') {
            return next('/')
        }
    }

    if (userStatus === 'restricted' && to.path !== '/' && !publicPages.includes(to.path)) {
        return next('/')
    }

    next()
})



export default router
